<!-- 
お知らせの一覧画面
@props
  itemList : お知らせの配列
  canAddInformation : お知らせを追加できる状態であればtrue、そうでなければfalseを指定する
-->

<template>
  <div>
    <!-- 表ヘッダ部のボタン -->
    <template v-if="!isCategory">
      <v-row 
        style="text-align: center;
        margin-top: 10px">
        <p style="font-size: 15px; margin: 10px"> </p>
        <v-col cols="auto" style="padding: 10px">
          <v-btn
            v-if="canAddInformation"
            color="primary"
            class="ma-2"
            @click="create"
          >
            新規登録
          </v-btn>
          <v-btn
            v-if="canAddInformation"
            color="primary"
            class="ma-2"
            @click="category"
          >
            分類登録・編集
          </v-btn>
          <v-btn
            color="primary"
            class="ma-2"
            @click="mailsetting"
          >
            メール通知設定
          </v-btn>
          <v-menu
            v-if="canAddInformation"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="ma-2"
                v-bind="attrs"
                v-on="on"
                :disabled="!selectionStatus.includes('contain.any')"
              >
                操作 <v-icon>mdi-chevron-down</v-icon></v-btn
              >
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                :disabled="!selectionStatus.includes(item.condition)"
                @click="item.event"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row v-if="!isInfoPreview" style="margin: 10px">
        <v-col
          cols="auto"
          style="align-items: center; margin: 10px; padding: 10px"
        >
          <v-row style="text-align: center; height: 25px">
            <p style="font-size: 20px; color: dodgerblue">登録日で絞り込む</p>
          </v-row>
          <v-row style="text-align: center">
            <start-date-picker
              :events="events"
              :searchStartDate="searchStartDate"
              :searchEndDate="searchEndDate"
              @on-update-registration-start-date="updateRegistrationStartDate"
            ></start-date-picker>
            <v-row align-content="center" style="text-align: center">
              <v-col style="align-items: center; font-size: 20px; margin: 10px; padding: 0px">から</v-col>
            </v-row>
            <end-date-picker
              :events="events"
              :searchStartDate="searchStartDate"
              :searchEndDate="searchEndDate"
              @on-update-registration-end-date="updateRegistrationEndDate"
            ></end-date-picker>
            </v-row>
        </v-col>
        <v-col
          v-if="false"
          cols="auto"
          style="margin: 10px; padding: 10px"
        >
          <v-row style="text-align: center; height: 25px">
            <p style="font-size: 20px; color: dodgerblue">分類で絞り込む</p>
          </v-row>
          <v-row>
            <v-menu bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="font-size: 24px"
                  class="ma-2"
                  width="200"
                  height="50"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :disabled="false"
                >
                {{ selectedCategory.substring(0, 6) }}
                <v-icon
                  style="margin-left: auto; padding: 0px;"
                >mdi-chevron-down</v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in categoryList"
                  :key="index"
                  :disabled="false"
                  @click="requestToSearch(item.category, 'category')"
                >
                  <v-list-item-title>{{ item.category }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-col>
        <v-col
          cols="auto"
          style="margin: 10px; padding: 10px"
        >
          <v-row style="text-align: center; height: 25px">
            <p style="font-size: 20px; color: dodgerblue">キーワードで絞り込む</p>
          </v-row>
          <v-row style="text-align: center">
            <v-text-field
              v-model="search"
              style="font-size: 24px"
              class="ma-2"
              height="50"
              outlined
              dense
              hide-details
              placeholder="キーワードを入力"
            >
              <template v-slot:append-outer>
                <v-btn
                  outlined
                  color="primary"
                  style="font-size: 20px"
                  @click="requestToSearch(search, 'all')"
                  >検索</v-btn
                >
              </template>
            </v-text-field>
          </v-row>
        </v-col>
        <v-col cols="auto" style="margin-left: auto; margin-top: auto; padding: 0px;">
          <v-chip
              color="primary"
              style="font-size: 18px"
              close
              @click="requestToSearch(null, 'all')"
            >
              絞り込みを解除する
          </v-chip>
        </v-col>
      </v-row>
    </template>
    <h2 v-if="!isInfoPreview" class="filtered-category-title">{{getCategoryName(categoryId)}}</h2>
    <div :class="{'border-container ma-6': isInfoPreview}">
      <h2 v-if="isInfoPreview" class="text-center info-title-style">{{getCategoryName(categoryId)}}</h2>
      <v-data-table
        locale="jp"
        mobile-breakpoint="0"
        v-model="selected"
        :headers="isCategoryHeaders"
        :items="itemList"
        :items2="categoryList"
        item-class="text-truncate"
        :custom-sort="sortFunction"
        item-key="recordId"
        v-bind:show-select="canAddInformation && !isInfoPreview"
        hide-default-footer
        :single-select="false"
        :search="searchCondition"
        :custom-filter="executeSearch"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        no-results-text="検索条件に合うデータがありません"
        no-data-text="データがありません"
        :hide-default-header="isInfoPreview"
      >
        <!-- ヘッダ -->
        <template v-slot:[`header.data-table-select`]="{ props, on }">
          <v-simple-checkbox
            v-if="false"
            :value="props.value || props.indeterminate"
            v-on="on"
            :indeterminate="props.indeterminate"
            dark
            :ripple="false"
            :disabled="true"
          />
        </template>
        <!-- 表示するセルのフォーマットの定義 -->
        <template
          v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
        >
          <v-simple-checkbox
            :value="isSelected"
            @input="select($event)"
            @click="selectedCheckbox(item)"
            :ripple="false"
          >
          </v-simple-checkbox>
        </template>
        <template v-slot:[`item.category`]="{ item }">
          <div style="font-size: 20px; word-break: break-all;"> {{ item.category }} </div>
        </template>
        <template v-slot:[`item.fileName`]="{ item }">
          <a
            v-if="item.fileName.substr(-4, 4) != '.pdf'"
            :href="item.fileUrl"
            style="font-size: 20px; word-break: break-all;"
            >
            {{ item.fileName }}
          </a>
          <a
            v-if="item.fileName.substr(-4, 4) == '.pdf'"
            :href="item.fileUrl"
            style="font-size: 20px; word-break: break-all;"
            @click.prevent="previewPdf(item)"
            >
            {{ item.fileName }}
          </a>
        </template>
        <template v-slot:[`item.recordDate`]="{ item }">
          <div style="font-size: 20px; word-break: break-all;"> {{ item.recordDate }} </div>
        </template>
      </v-data-table>
      <div v-if="isInfoPreview" class="button-container">
        <v-btn
          color="primary"
          class="ma-2"
          @click="showCategorizedList(categoryId)"
        >
          {{ getCategoryName(categoryId) }}一覧
        </v-btn>
      </div>
    </div>
    <div v-if="!isInfoPreview" class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
    <!-- ダイアログ -->
    <confirm-dialog ref="confirm_information_delete" @on-click-ok="deleteInformation">
      お知らせを削除します。よろしいですか？
    </confirm-dialog>
  </div>
</template>

<script>
import SearchStartDatePicker from "../../components/information-edits/start-date-picker.vue";
import SearchEndDatePicker from "../../components/information-edits/end-date-picker.vue";
import ConfirmDialog from "../dialog/confirm.vue";
import valueConverter from "../../logic/common/value-converter";
import Api from "@/logic/api/api.js";

export default {
  props: ["itemList", "canAddInformation", "isInfoPreview", "isCategory", "categoryId"],
  components: {
    "confirm-dialog": ConfirmDialog,
    "start-date-picker": SearchStartDatePicker,
    "end-date-picker": SearchEndDatePicker,
  },
  computed: {
    /**
     * 各チェックボックスの選択状態
     */
    selectionStatus() {
      const selectedInformationList = this.selectedInformationList;
      if (selectedInformationList.length == 0) {
        return [];
      }
      return ["contain.any"];
    },
    /**
     * 選択されたお知らせの一覧
     */
    selectedInformationList() {
      return this.selected.filter((item) => item.informationEdit.editable);
    },
    categoryList() {
      return this.$store.getters.manageCategoryList;
    },
    informationList() {
      return this.$store.getters.manageInformationList;
    },
    isCategoryHeaders() {
      if ((this.isInfoPreview && !this.isCategory) || (this.categoryId === 0)) {
        return [
          {
            text: "分類",
            align: "start",
            value: "category",
            class: "grey darken-1 white--text text-subtitle-1",
            width: "25%",
          },
          {
            text: "ファイル",
            align: "start",
            value: "fileName",
            class: "grey darken-1 white--text text-subtitle-1",
            width: "55%",
          },
          {
            text: "登録日",
            align: "start",
            value: "recordDate",
            class: "grey darken-1 white--text text-subtitle-1",
            width: "20%",
          },
        ];
      } else {
        return [
          {
            text: "ファイル",
            align: "start",
            value: "fileName",
            class: "grey darken-1 white--text text-subtitle-1",
            width: "55%",
          },
          {
            text: "登録日",
            align: "start",
            value: "recordDate",
            class: "grey darken-1 white--text text-subtitle-1",
            width: "20%",
          },
        ];
      }
    },
  },
  data() {
    if (!this.isCategory) {
      this.$nextTick(() => {
        this.reloadData();
      });
    }
    return {
      // 検索条件（入力中）
      search: "",
      // 検索条件（一覧反映中）
      searchCondition: "",
      // 表示中のページ番号
      page: 1,
      // ページ数
      pageCount: 0,
      // ページあたりに表示するユーザー件数
      itemsPerPage: 20,
      // 選択中のユーザー情報
      selected: [],
      // 一覧のヘッダ定義
      headers: [],
      // 画面上部の「操作」で表示する操作ボタンの定義
      items: [
        {
          title: "削除",
          condition: "contain.any",
          event: () => {
            this.$refs.confirm_information_delete.showDialog();
          },
        },
      ],
      // 画面上部の「操作」で表示する操作ボタンの定義
      items2: [
        {
          title: "category",
          condition: "contain.any",
        },
      ],
      searchStartDate: "",
      searchEndDate: "",
      searchStartDateInit: "",
      searchEndDateInit: "",
      selectedCategory: "分類を選択",
      changeStartDate: "false",
      changeEndDate: "false",
      pdfFileUrl: "bbb",
      pdfFileName: "ccc",
      events: "",
    };
  },
  watch: {
    $route() {
      this.searchStartDate =  "";
      this.searchEndDate =  "";
      this.searchStartDateInit =  "";
      this.searchEndDateInit =  "";
      this.selected = [];
      this.$nextTick(() => {
        this.reloadData();
      });
    },
  },
  methods: {
    /**
     * お知らせを作成する
     */
    create() {
      this.$router.push("/information/edit/create");
    },
    /**
     * 分類リストを表示する
     */
    category() {
      this.$router.push("/category");
    },
    /**
     * メール通知設定画面を表示する
     */
     mailsetting() {
      this.$router.push("/categorymail");
    },
    /**
     * アカウントを編集する
     */
    edit(uid) {
      this.$router.push(`/account/edit/${uid}`);
    },
    /**
     * 分類ごとのお知らせ一覧を表示する
     */
    showCategorizedList(id) {
      this.$router.push(`/information/${id}`);
    },
    /**
     * 並び替えをカスタマイズする
     */
    sortFunction(items, sortBy, sortDesc) {
      if (sortBy.length == 0) {
        const userId = this.$store.getters.userId;
        return valueConverter.dataTableCustomSort(
          items,
          ["userName"],
          [false],
          (a, b) => {
            // ログインユーザーと同じIDであれば先頭に表示する
            if (userId == a.uid) {
              return -1;
            }
            if (userId == b.uid) {
              return 1;
            }
            // ログインユーザー以外のユーザーはデフォルトの比較方法で判定を行う
            return undefined;
          }
        );
      }
      return valueConverter.dataTableDefaultSort(items, sortBy, sortDesc);
    },
    /**
     * お知らせを削除する
     */
    deleteInformation() {
      this.$emit("on-delete-information", this.selectedInformationList);
      this.selected = [];
    },
    /**
     * 検索条件を一覧に反映する
     */
    requestToSearch(search, searchTarget) {
      this.searchTarget = searchTarget;
      console.log("requestToSearch");
      console.log("searchTarget = " + searchTarget);
      console.log("search = " + search);
      const startSearch = search;
      if (this.searchTarget == "category") {
        console.log("分類選択　日付、キーワードを初期値に戻す");
        if (this.searchStartDate != this.searchStartDateInit) {
          this.changeStartDate = true;
          this.searchStartDate = this.searchStartDateInit;
        }
        if (this.searchEndDate != this.searchEndDateInit) {
          this.changeEndDate = true;
          this.searchEndDate = this.searchEndDateInit;
        }

        this.search = "";
      }
      if (this.searchTarget == "all") {
        console.log("キーワード入力　分類、日付を初期値に戻す");
        this.selectedCategory = "分類を選択";
        if (this.searchStartDate != this.searchStartDateInit) {
          this.changeStartDate = true;
          this.searchStartDate = this.searchStartDateInit;
        }
        if (this.searchEndDate != this.searchEndDateInit) {
          this.changeEndDate = true;
          this.searchEndDate = this.searchEndDateInit;
        }
        if (search == null) {
          this.search = "";
        }
      }
      if (this.searchTarget == "date") {
        console.log("日付選択　分類、キーワードを初期値に戻す");
        this.selectedCategory = "分類を選択";
        this.search = "";
      }
      this.searchCondition = startSearch;
    },
    /**
     * 検索を実施する
     */
    executeSearch(_, search, item) {
      console.log("executeSearch");
      console.log("search = " + search);
      console.log("item = " + item);
      if (search == null || search == "") {
        return true;
      }
      // 分類で完全一致検索する
      if (this.searchTarget == "category") {
        this.selectedCategory = search;
        const category = item.category;
        if (category.includes(search)) {
          return true;
        }
      }

      if (this.searchTarget == "all") {
        const category = item.category;
        const fileName = item.fileName;
        const recordDate = item.recordDate;
        if (category.includes(search)) {
          return true;
        }
        if (fileName.includes(search)) {
          return true;
        }
        if (recordDate.includes(search)) {
          return true;
        }
      }

      if (this.searchTarget == "date") {
        const recordDate = item.recordDate;
        console.log("recordDate for search = " + search.substring(0, 10));
        console.log("[search] searchStartDate = " + this.searchStartDate.replace(/-/g, "/").substring(0, 10));
        console.log("[search] searchEndDate = " + this.searchEndDate.replace(/-/g, "/").substring(0, 10));
        if (recordDate.substring(0, 10) >= this.searchStartDate.replace(/-/g, "/").substring(0, 10)
            && recordDate.substring(0, 10) <= this.searchEndDate.replace(/-/g, "/").substring(0, 10)) {
          return true;
        }
      }
      return false;
    },
    /**
     * 分類/お知らせを一覧で取得する
     */
     reloadData() {
      this.$store.commit("setWaiting", true);

      const apiRequests = [];
      const processList = [];

      // 分類を取得する
      apiRequests.push("category.list");
      processList.push(
        Api.call("/admin/information/category", {})
      );

      Promise.all(processList)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          //APIから取得した結果を画面に表示する
          let categoryList = [];
          if (apiRequests.includes("category.list")) {
            const idx = apiRequests.indexOf("category.list");
            const apiRes = result[idx] || {};
            const raw = Array.isArray(apiRes.categorys) ? apiRes.categorys : [];

            // is_restricted が true のものを除外
            categoryList = raw.filter(item => item?.is_restricted !== true);
            console.log("categoryList = " + JSON.stringify(categoryList));

          }
          //APIから取得した結果を画面に表示する
          let informationList = [];
          if (apiRequests.includes("information")) {
            informationList = result[apiRequests.indexOf("information")].informations;
            informationList.sort(function(a,b){
              if(a.record_date > b.record_date) return -1;
              if(a.record_date < b.recordD_date) return 1;
              return 0;
            });            
            console.log("informationList = " + JSON.stringify(informationList));
          }
          this.$store.commit(
            "setManageCategoryList",
            categoryList.map((category) => {
              return {
                recordId: category.record_id,
                category: category.category,
                order: category.order,
                usedNumber: category.used_number,
                categoryEdit: {
                  editable: true,
                },
              };
            })
          );
          console.log("初期日時を設定");
          var sortList = this.itemList;
          sortList.sort(function(a,b){
            if(a.recordDate > b.recordDate) return -1;
            if(a.recordDate < b.recordDate) return 1;
            return 0;
          });
          console.log("ソート後のsortList = " + sortList);
          this.changeStartDate = true;
          this.changeEndtDate = true;
          if (sortList.length) {
            this.searchStartDate = this.getStringFromDate(sortList[sortList.length - 1].recordDate);
            this.searchEndDate = this.getStringFromDate(sortList[0].recordDate);
          } else {
            this.searchStartDate = this.getStringFromDate(this.getToday());
            this.searchEndDate = this.getStringFromDate(this.getToday());
          }
          this.searchStartDateInit = this.searchStartDate;
          this.searchEndDateInit = this.searchEndDate;
          console.log("searchStartDate in list-table = " + this.searchStartDate);
          console.log("searchEndDate in list-table = " + this.searchEndDate);
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        }
      );
    },
    getToday() {
      let dt = new Date();
      let y = dt.getFullYear();
      let m = ('00' + (dt.getMonth() + 1)).slice(-2);
      let d = ('00' + dt.getDate()).slice(-2);
      return (y + '-' + m + '-' + d);
    },
    /**
     * 登録日を更新する
     */
    updateRegistrationStartDate(registrationDate) {
      console.log("updateRegistrationStartDate is called");
      console.log("this.changeStartDate at start = " + this.changeStartDate);
      console.log("registrationDate = " + registrationDate);
/*       // API指定用登録日
      this.date_api = registrationDate.replace(/-/g, "/"); */
      const startDate = this.searchStartDate;
      const endDate = this.searchEndDate;
      console.log("startDate = " + Number(startDate.replace(/-/g, "")));
      console.log("endDate = " + Number(endDate.replace(/-/g, "")));
      if(this.changeStartDate == false) {
        if(Number(startDate.replace(/-/g, "")) <= Number(endDate.replace(/-/g, ""))) {
          console.log("this.requestToSearch(this.searchStartDate, 'date')");
          this.searchStartDate = registrationDate;
          this.requestToSearch(this.searchStartDate, 'date');
        }
      } else {
        this.changeStartDate = false;
      }
      console.log("this.changeStartDate at end = " + this.changeStartDate);
    },
    /**
     * 登録日を更新する
     */
     updateRegistrationEndDate(registrationDate) {
      console.log("updateRegistrationEndDate is called");
      console.log("registrationDate = " + registrationDate);
/*       // API指定用登録日
      this.date_api = registrationDate.replace(/-/g, "/"); */
      this.searchEndDate = registrationDate;
      const startDate = this.searchStartDate;
      const endDate = this.searchEndDate;
      console.log("startDate = " + Number(startDate.replace(/-/g, "")));
      console.log("endDate = " + Number(endDate.replace(/-/g, "")));
      if(this.changeEndDate == false) {
        if(Number(startDate.replace(/-/g, "")) <= Number(endDate.replace(/-/g, ""))) {
          console.log("this.requestToSearch(this.searchEndDate, 'date')");
          this.requestToSearch(this.searchEndDate, 'date');
        }
      } else {
        this.changeEndDate = false;
      }
    },

    getStringFromDate(date) {
      var format_date = date.replace(/\//g, "-");
      console.log("date = " + format_date);
      return format_date;
    },
    selectedCheckbox(item) {
      if (this.selected.length >= 1) {
        if (this.selected[0].recordId != item.recordId){
          this.selected = [];
          this.selected[0] = item;
        } else {
          this.selected = [];          
        }
      }
    },
    previewPdf(item) {
      console.log("openPdf is called");
      console.log("item.fileUrl = " + item.fileUrl);
      this.$router.push(`/information/preview/${item.recordId}`);
    },
    /**
     * 分類IDからカテゴリ名を返す。0の場合は”新着情報”を返す
     */
    getCategoryName(recordId) {
      const categories = this.$store.getters.manageCategoryList;
      // recordIdが0の場合は"新着情報"を返す
      if (recordId === 0) {
        return "新着情報";
      }
      // recordIdに対応するcategoryを検索
      const matchedCategory = categories.find(category => category.recordId === recordId);
      // 一致するオブジェクトがあればcategoryを返し、なければnullを返す
      return matchedCategory ? matchedCategory.category : null;
    },
  },
};
</script>

<style>
.filtered-category-title {
  font-weight: 300; /* フォントを細くする */
  padding: 10px; /* 周囲のパディングを追加 */
}
.info-title-style {
  font-weight: 300; /* フォントを細くする */
  text-decoration: underline; /* アンダーラインを引く */
}
.border-container {
  border: 1px solid #ccc; /* 矩形のボーダー */
  border-radius: 8px; /* 角を丸める（必要に応じて） */
  padding: 32px; /* 内側の余白 */
  background-color: white; /* 背景色 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* 軽い影をつける */
}
.button-container {
  display: flex; /* フレックスボックスを使用 */
  justify-content: flex-end; /* ボタンを右寄せに配置 */
  margin-top: 20px; /* ボタンの上に余白を追加 */
}
</style>
